module.exports = __webpack_public_path__ + "static/media/club.6b6d75c7.png";